import { Setting } from '../setting';
import { mapCollection } from '../../utils/collection.utils';

export class SettingBuilder {

  static fromJson(json): Setting {
    return (json) ? new Setting(
      json.hash,
      json.description,
      json.value,
      json.name
    ) : null;
  }

  static fromJsonList(list): Setting[] {
    return mapCollection(SettingBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/setting-builder.ts